import StatisticsBoard from './StatisticsBoard'
import connect from './connect'

export default connect(StatisticsBoard)


// WEBPACK FOOTER //
// ./src/components/StatisticsBoard/index.js